var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 10,
    height: 10,
    transform: "translate(1173 205)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_26",
    "data-name": "Mask Group 26",
    transform: "translate(-1173 -205)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(1173 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M8.033.091a.312.312,0,0,0-.442,0L6.562,1.121,8.879,3.437,9.908,2.409a.312.312,0,0,0,0-.442L8.033.091Zm.4,3.788L6.12,1.562,2.058,5.625h.129a.312.312,0,0,1,.312.312V6.25h.312a.312.312,0,0,1,.312.312v.312h.312a.312.312,0,0,1,.312.312V7.5h.312a.312.312,0,0,1,.312.312v.129ZM3.77,8.546a.312.312,0,0,1-.02-.109V8.125H3.437a.312.312,0,0,1-.312-.312V7.5H2.812A.312.312,0,0,1,2.5,7.187V6.875H2.187a.312.312,0,0,1-.312-.312V6.25H1.562a.312.312,0,0,1-.109-.02l-.112.111a.312.312,0,0,0-.069.1L.022,9.571a.312.312,0,0,0,.406.406l3.125-1.25a.312.312,0,0,0,.1-.069l.111-.111Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEdit);
export default __webpack_public_path__ + "static/media/white-edit.1926052648969f1e1b31c8d4a244712e.svg";
export { ForwardRef as ReactComponent };